import type { IRMetricKey } from '../types';

import { create } from 'zustand';

export interface IReportFilter {
  metricHovered?: IRMetricKey;
  setMetricHovered: (metricHovered?: IRMetricKey) => void;
}

export const useReportFilter = create<IReportFilter>()((set) => ({
  metricHovered: undefined,
  setMetricHovered: (metricHovered) => set({ metricHovered }),
}));
